<div class="modal-content">
    <div class="modal-header text-center" *ngIf="config.title">
      {{ config.title }}
    </div>
    <div class="modal-body qrcode">
      <div class="row">
        <div class="col">
          <qr-code [value]="config.data" size="300" errorCorrectionLevel="M"
            centerImageSize="60" centerImageSrc="./assets/favicon.png">
          </qr-code>
        </div>
      </div>
      <div class="row" *ngIf="config.instructions">
        <div class="col">
          <p><em>{{ config.instructions }}</em></p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="ok($event)">{{ config.okText }}</button>
        <button type="button" class="btn btn-secondary"
          *ngIf="config.cancelText != ''"
          (click)="cancel($event)">{{ config.cancelText }}
        </button>
    </div>
</div>
